export enum ChecklistActionTypes {
  LOAD_CHECKLISTS_SUCCEEDED = 'LOAD_CHECKLISTS_SUCCEEDED',
  LOAD_TEMPLATE_CHECKLISTS_REQUEST = 'LOAD_TEMPLATE_CHECKLISTS_REQUEST',
  LOAD_COMPLETED_CHECKLISTS_REQUEST = 'LOAD_COMPLETED_CHECKLISTS_REQUEST',
  LOAD_CHECKLISTS_FAILED = 'LOAD_CHECKLISTS_FAILED',
  LOAD_CHECKLIST_REQUEST = 'LOAD_CHECKLIST_REQUEST',
  LOAD_CHECKLIST_SUCCEEDED = 'LOAD_CHECKLIST_SUCCEEDED',
  LOAD_CHECKLIST_FAILED = 'LOAD_CHECKLIST_FAILED',
  LOAD_COMPLETED_CHECKLISTS_NAMES_REQUEST = 'LOAD_COMPLETED_CHECKLISTS_NAMES_REQUEST',
  LOAD_COMPLETED_CHECKLISTS_NAMES_SUCCEEDED = 'LOAD_COMPLETED_CHECKLISTS_NAMES_SUCCEEDED',
  LOAD_COMPLETED_CHECKLISTS_NAMES_FAILED = 'LOAD_COMPLETED_CHECKLISTS_NAMES_FAILED',
  CREATE_CHECKLIST_REQUEST = 'CREATE_CHECKLIST_REQUEST',
  CREATE_CHECKLIST_SUCCEEDED = 'CREATE_CHECKLIST_SUCCEEDED',
  CREATE_CHECKLIST_FAILED = 'CREATE_CHECKLIST_FAILED',
  UPDATE_CHECKLIST_REQUEST = 'UPDATE_CHECKLIST_REQUEST',
  UPDATE_CHECKLIST_SUCCEEDED = 'UPDATE_CHECKLIST_SUCCEEDED',
  UPDATE_CHECKLIST_FAILED = 'UPDATE_CHECKLIST_FAILED',
  DELETE_CHECKLIST_REQUEST = 'DELETE_CHECKLIST_REQUEST',
  DELETE_CHECKLIST_SUCCEEDED = 'DELETE_CHECKLIST_SUCCEEDED',
  DELETE_CHECKLIST_FAILED = 'DELETE_CHECKLIST_FAILED',
}
